

































































import { PropType } from 'vue';
import BaseDialog from '@/components/BaseDialog.vue';
import { getCopyStakeGames } from '@/api/CopyStake/Game';
import {
  IAutoclickerGameCreatePayload,
  IAutoclickerGameUpdatePayload,
  TAutoclickerGameData,
  ValidationRules
} from '@/api/schema';
import {
  createAutoclickerGame,
  updateAutoclickerGame
} from '@/api/CopyStake/AutoClicker';
import { errorToastMessage } from '@/helpers/errorToastMessage';
import { AxiosError } from 'axios';
import * as vr from '@/helpers/validation';
import { mapGetters } from 'vuex';

export default {
  name: 'CopyStakeAutoclickerGameDialog',
  components: {
    BaseDialog
  },
  props: {
    value: {
      type: Boolean,
      default: (): boolean => false
    },
    game: {
      type: Object as PropType<TAutoclickerGameData>,
      default: (): null => null
    }
  },
  data(): any {
    return {
      selectedGame: null,
      gameUrl: '',
      searchGameQuery: '',
      gamesList: [],

      loading: {
        submit: false,
        gamesList: false
      },
      isFormValid: false
    };
  },
  computed: {
    ...mapGetters('Onboarding', ['isUndergroundCasinoGamesIntegrationType']),
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean): void {
        this.$emit('input', value);
      }
    },
    isEdit(): boolean {
      return !!this.game;
    },
    dialogTitle(): string {
      if (this.isEdit) {
        return 'Edit Game';
      }

      return 'Add Game';
    },
    isHideGameUrlInput(): boolean {
      return this.isUndergroundCasinoGamesIntegrationType;
    },
    rules(): ValidationRules {
      return {
        game: [vr.required],
        gameUrl: this.isHideGameUrlInput ? [] : [vr.required, vr.url]
      };
    }
  },
  watch: {
    async value(open: boolean): Promise<void> {
      await this.resetForm();

      if (open) {
        if (!this.gamesList.length) {
          await this.getGamesList();
        }

        if (this.game) {
          this.selectedGame =
            this.gamesList.find(
              (game: TAutoclickerGameData) => game.id === this.game.gameId
            ) || null;
          this.gameUrl = this.game?.gameUrl;

          this.$nextTick(() => {
            this.$refs.form?.validate();
          });
        }
      }
    }
  },
  methods: {
    async getGamesList(): Promise<void> {
      this.loading.gamesList = true;

      await getCopyStakeGames({
        permittedStates: true,
        size: 1000,
        page: 0
      })
        .then((data) => {
          this.gamesList = data.content;
        })
        .catch((err: AxiosError) => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.loading.gamesList = false;
        });
    },
    async createGame(): Promise<void> {
      this.loading.submit = true;

      const payload: IAutoclickerGameCreatePayload = {
        gameId: this.selectedGame.id
      };

      if (!this.isHideGameUrlInput) {
        payload.gameUrl = this.gameUrl;
      }

      createAutoclickerGame(payload)
        .then(() => {
          this.$toast.success('Game created successfully');

          this.$emit('submit');
          this.closeDialog();
        })
        .catch((err: AxiosError) => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.loading.submit = false;
        });
    },
    async updateGame(): Promise<void> {
      this.loading.submit = true;

      const payload: IAutoclickerGameUpdatePayload = {
        gameUrl: this.gameUrl
      };

      updateAutoclickerGame(this.game.id, payload)
        .then(() => {
          this.$toast.success('Game updated successfully');

          this.$emit('submit');
          this.closeDialog();
        })
        .catch((err: AxiosError) => {
          errorToastMessage(err);
        })
        .finally(() => {
          this.loading.submit = false;
        });
    },
    handlerClickSubmitButton(): void {
      if (this.loading.submit) return;

      if (this.isEdit) {
        this.updateGame();
      } else {
        this.createGame();
      }
    },
    async handlerClickCloseBtn(): Promise<void> {
      if (this.loading.submit) return;

      this.closeDialog();
    },
    resetForm(): void {
      this.selectedGame = null;
      this.gameUrl = '';

      this.isFormsValid = false;
    },
    closeDialog(): void {
      this.showDialog = false;
      this.$emit('close');
    }
  }
};
